import React, { useState, useEffect, useContext } from "react";
import { AiOutlineArrowLeft } from "react-icons/ai";
import axiosInstance from "../../../../config/axios";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";
import { socketContextType } from "index";
import SocketContext from "socket-context";
import { UserInfoMapperSocketHandler } from "utils/UserInfoMapper";
import { validateAndCreateSocketIfExist } from "utils/SocketValidator";
import { toast } from "react-toastify";

interface Props {
  badge: { alt: string; src: string };
  onBack: () => void;
}

const ShareBadgePopover: React.FC<Props> = ({ badge, onBack }) => {
  const {
    live: {
      settings: { batch },
    },
    auth,
  } = useSelector((s: RootState) => s);
  const session_id = useSelector(
    (state: RootState) => state.live.settings.roomId
  );

  const participants = useSelector(
    (state: RootState) => state.live.settings.participants
  );

  const batchData = useSelector((state: RootState) => state.live.settings.batch);
  const { trainer } = useSelector((state: RootState) => state.live.settings);


  // const session_id = localStorage.getItem("sessionId");
  const [newParticipants, setNewParticipants] = useState([]);

  const socketList: socketContextType[] = useContext(SocketContext);
  let userInfoHandler = new UserInfoMapperSocketHandler();

  const [checked, setChecked] = useState<Record<number, boolean>>({});
  const [checkBoxVal, setCheckBoxVal] = useState<string[]>([]);

  const userData = useSelector((state: any) => state.auth.user);

  const [sessionData, setSessionData] = useState<any>([]);

  useEffect(() => {
    setNewParticipants(batchData?.participants);
  }, [batchData?.participants, trainer]);


  useEffect(() => {
    setCheckBoxVal([]);
    setChecked({});
  }, [badge]);

  const toggle = (id: any, email: any) => {
    setChecked((prev) => {
      const newChecked = { ...prev, [id]: !prev[id] };
      console.log("New checked state:", newChecked);
      return newChecked;
    }); if (checkBoxVal.includes(email)) {
      setCheckBoxVal(checkBoxVal.filter((e) => e !== email));
    } else {
      setCheckBoxVal([...checkBoxVal, email]);
    }
  };

  useEffect(() => {
    console.log("checkBoxVal", checkBoxVal);

  }, [checkBoxVal]);

  const sendBadges = async () => {
    if (checkBoxVal.length < 1) {
      toast.warn("Please select at least one participant");
      return;
    }

    try {
      const badgeData = {
        achievementName: badge.alt,
        sessionId: session_id,
        programId: batch?.programId,
        receiverEmail: checkBoxVal,
        senderId: auth.user?.id,
        senderName: auth.user?.name,
      };

      const response: any = await axiosInstance.post("trainee/save_badges", badgeData);

      if (response.code === 200) {
        toast.success(response.data?.message || "Badge shared successfully");

        userInfoHandler = validateAndCreateSocketIfExist(session_id, () => { }, socketList);
        const objUserReactionData = {
          reaction_type: badge.alt,
          reaction_sub_type: badge.alt,
          reacted_by: auth.user?.name,
          reacted_by_type: "trainee",
          sent_to: checkBoxVal,
        };
        userInfoHandler.sendMessage(
          JSON.stringify({
            type: "show_badges",
            sub_type: "badge_share_count",
            user_badge_data: objUserReactionData,
            room_id: session_id,
          })
        );
        fetchSession();
        setCheckBoxVal([]);
        setChecked({});
        onBack();
      } else {
        toast.error("Failed to share badge");
      }
    } catch (err) {
      console.error("share-badge error:", err);
      toast.error("Error sharing badge");
    }
  };

  const fetchSession = async () => {
    try {
      const session = await axiosInstance.post("/trainee/live_session_plan_preview_trainee", {
        session_map_id: session_id
      });

      const responseData = session?.data?.responseData || {};
      const allActivities = [
        ...(responseData.prePlannedActivities || []),
        ...(responseData.quickSetupActivities || [])
      ];

      setSessionData(allActivities);

      const launchData = allActivities.find((el: any) => el.status === "LAUNCH");

      if (launchData?.id) {
        for (let x of checkBoxVal) {
          await saveActions(badge.alt, x, launchData);
        }
      }

    } catch (error) {
      console.error("Error fetching session:", error);
    }
  };


  const saveActions = async (subType: string, email: string, launchData: any) => {
    try {
      console.log("sessionData", sessionData);

      const targetTrainer = participants?.find(
        (el: any) => el.userEmail === email && el.role === "trainer"
      );
      const targetTrainee = participants?.find(
        (el: any) => el.userEmail === email && el.role === "trainee"
      );

      const isTraineeToTrainee = userData?.role === "trainee" && targetTrainee;
      const engagementType = isTraineeToTrainee ? "LL_BADGES" : "LT_BADGES";

      const obj = {
        engagementType,
        userId: targetTrainer?.userId || null,
        toParticipantId: targetTrainee?.userId || null,
        sessionActivityExecutionLogId: launchData?.id || null,
        isRead: "NO",
        participantId: userData?.id || null,
        subType,
      };

      if (!obj.participantId) {
        console.error("Missing participantId (userData?.id). Cannot save action.");
        return;
      }

      if (!obj.toParticipantId && !obj.userId) {
        console.error("No valid target participant found for email:", email);
        return;
      }

      await axiosInstance.post("/session/save_session_actions_log", obj);
      console.log("Action saved successfully:", obj);
    } catch (error) {
      console.error("Failed to save session action:", error);
    }
  };


  return (
    <div className="w-full h-full">
      <div className="flex items-center space-x-4 mobile:mb-2">
        <button
          onClick={onBack}
          className="w-8 h-8 bg-[#24272C] rounded-full flex items-center justify-center hover:bg-white/10 shadow-[6px_6px_12px_0px_#00000010,_-6px_-6px_12px_0px_#FFFFFF10] mt-2"
        >
          <AiOutlineArrowLeft size={18} />
        </button>
      </div>

      <div className="flex items-start space-x-6 mobile:flex-col mobile:space-x-0 mobile:space-y-2">
        <img
          src={badge.src}
          alt={badge.alt}
          className="w-36 flex-shrink-0 mt-2 mobile:w-24 mobile:mx-auto"
        />

        <div className="flex-1 bg-[#24272C] rounded-2xl p-6 mobile:p-4">
          <h3 className="bg-[#2A2B30] rounded-full px-6 py-2 text-white text-sm font-medium mb-4 whitespace-nowrap mobile:text-xs mobile:mb-2 mobile:text-center">
            Share &lt;{badge.alt}&gt; badge with –
          </h3>
          <div className="flex gap-4 mobile:flex-col mobile:gap-2">
            {(() => {
              const participants = [
                ...(trainer ? [{ ...trainer, name: trainer.fullname }] : []),
                ...(batch?.participants?.filter((p: any) => p.email !== userData?.email) || []),
              ];
              const scrollable = participants.length > 5;

              return (
                <div
                  className={`flex-1 pr-2 space-y-3 text-sm text-white mobile:space-y-2 mobile:text-xs ${scrollable
                      ? "overflow-y-auto max-h-[300px] mobile:max-h-[200px] custom-scrollbar"
                      : ""
                    }`}
                >
                  {participants.map((p: any) => (
                    <div
                      key={p.id}
                      className="flex justify-between items-center bg-[#2A2B30] py-2 px-3 rounded mobile:px-2"
                    >
                      <span>{p.name}</span>
                      <input
                        type="checkbox"
                        className="w-5 h-5 accent-purple-600 mobile:w-4 mobile:h-4"
                        checked={!!checked[p.id]}
                        onChange={() => {
                          console.log("Checkbox clicked for:", p.id, p.email);
                          toggle(p.id, p.email);
                        }}
                      />
                    </div>
                  ))}
                </div>
              );
            })()}

            <div className="flex-shrink-0 pt-1 mobile:flex mobile:justify-center">
              <button
                onClick={sendBadges}
                onTouchEnd={sendBadges}
                className="bg-[#5F488A] hover:bg-[#5F488A]/80 px-6 py-2 rounded-full text-[#E9BE50] whitespace-nowrap mobile:px-4 mobile:py-1 mobile:text-xs"
              >
                Share
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareBadgePopover;